<template>
  <router-link to="/">
    <div class="px-logo" id="px-logo-box">
      <canvas id="px-logo"/>
      <span class="label beta"/>
    </div>
  </router-link>
</template>

<script>
import setupLogo from '../../../helpers/logo-setup'

export default {
  name: 'HeaderLogo',

  mounted: function () {
    setupLogo({ logoId: 'px-logo-box', canvasId: 'px-logo' })
  }
}
</script>
